"use client";

import * as Sentry from "@sentry/nextjs";
import Error from "next/error";
import { useEffect } from "react";
import { isDev } from "@/helpers";
import { toast } from "react-toastify";

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    !isDev() && Sentry.captureException(error);
    console.error(error);
    toast.error("Erro inesperado! caso persista, favor contatar o suporte");
  }, [error]);

  return (
    <html>
      <body>
        <Error statusCode={500} title={"Erro inesperado!"} />
        <button onClick={() => reset()}>Tentar novamente?</button>
      </body>
    </html>
  );
}
